export default "__VITE_ASSET__SrIOudPf__"